/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  EInvoicingCustomerSearchRequest,
  EInvoicingSettingsResponse,
  EInvoicingSubmission,
  EInvoicingSubmissionDetail,
  EInvoicingSupplier,
  Error,
  HandleFlowinWebhookBody,
  ListEInvoicingSubmissions200,
  ListEInvoicingSubmissionsParams,
  RegisterEInvoicingSupplierRequest,
  SearchEInvoicingCustomer200,
  SendEInvoiceRequest,
  UpdateEInvoicingSettingsRequest,
  UpdateEInvoicingSupplierRequest,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Get the current e-invoicing settings for the entity.
 * @summary Get e-invoicing settings
 */
export type getEInvoicingSettingsResponse200 = {
  data: EInvoicingSettingsResponse
  status: 200
}

export type getEInvoicingSettingsResponse400 = {
  data: Error
  status: 400
}

export type getEInvoicingSettingsResponse401 = {
  data: Error
  status: 401
}

export type getEInvoicingSettingsResponse403 = {
  data: Error
  status: 403
}

export type getEInvoicingSettingsResponse404 = {
  data: Error
  status: 404
}

export type getEInvoicingSettingsResponse500 = {
  data: Error
  status: 500
}

export type getEInvoicingSettingsResponseSuccess = (getEInvoicingSettingsResponse200) & {
  headers: Headers;
};
export type getEInvoicingSettingsResponseError = (getEInvoicingSettingsResponse400 | getEInvoicingSettingsResponse401 | getEInvoicingSettingsResponse403 | getEInvoicingSettingsResponse404 | getEInvoicingSettingsResponse500) & {
  headers: Headers;
};

export type getEInvoicingSettingsResponse = (getEInvoicingSettingsResponseSuccess | getEInvoicingSettingsResponseError)

export const getGetEInvoicingSettingsUrl = () => {


  

  return `/e-invoicing/settings`
}

export const getEInvoicingSettings = async ( options?: RequestInit): Promise<getEInvoicingSettingsResponse> => {
  
  return customFetch<getEInvoicingSettingsResponse>(getGetEInvoicingSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update e-invoicing settings for the entity. Only sandbox entities can enable e-invoicing unless live mode is explicitly enabled.
 * @summary Update e-invoicing settings
 */
export type updateEInvoicingSettingsResponse200 = {
  data: EInvoicingSettingsResponse
  status: 200
}

export type updateEInvoicingSettingsResponse400 = {
  data: Error
  status: 400
}

export type updateEInvoicingSettingsResponse401 = {
  data: Error
  status: 401
}

export type updateEInvoicingSettingsResponse403 = {
  data: Error
  status: 403
}

export type updateEInvoicingSettingsResponse404 = {
  data: Error
  status: 404
}

export type updateEInvoicingSettingsResponse422 = {
  data: ValidationError
  status: 422
}

export type updateEInvoicingSettingsResponse500 = {
  data: Error
  status: 500
}

export type updateEInvoicingSettingsResponseSuccess = (updateEInvoicingSettingsResponse200) & {
  headers: Headers;
};
export type updateEInvoicingSettingsResponseError = (updateEInvoicingSettingsResponse400 | updateEInvoicingSettingsResponse401 | updateEInvoicingSettingsResponse403 | updateEInvoicingSettingsResponse404 | updateEInvoicingSettingsResponse422 | updateEInvoicingSettingsResponse500) & {
  headers: Headers;
};

export type updateEInvoicingSettingsResponse = (updateEInvoicingSettingsResponseSuccess | updateEInvoicingSettingsResponseError)

export const getUpdateEInvoicingSettingsUrl = () => {


  

  return `/e-invoicing/settings`
}

export const updateEInvoicingSettings = async (updateEInvoicingSettingsRequest: UpdateEInvoicingSettingsRequest, options?: RequestInit): Promise<updateEInvoicingSettingsResponse> => {
  
  return customFetch<updateEInvoicingSettingsResponse>(getUpdateEInvoicingSettingsUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateEInvoicingSettingsRequest,)
  }
);}
  

/**
 * Register the entity as an e-invoicing supplier with Flowin. This starts the KYC/onboarding process.
 * @summary Register supplier
 */
export type registerEInvoicingSupplierResponse201 = {
  data: EInvoicingSupplier
  status: 201
}

export type registerEInvoicingSupplierResponse400 = {
  data: Error
  status: 400
}

export type registerEInvoicingSupplierResponse401 = {
  data: Error
  status: 401
}

export type registerEInvoicingSupplierResponse403 = {
  data: Error
  status: 403
}

export type registerEInvoicingSupplierResponse404 = {
  data: Error
  status: 404
}

export type registerEInvoicingSupplierResponse422 = {
  data: ValidationError
  status: 422
}

export type registerEInvoicingSupplierResponse500 = {
  data: Error
  status: 500
}

export type registerEInvoicingSupplierResponseSuccess = (registerEInvoicingSupplierResponse201) & {
  headers: Headers;
};
export type registerEInvoicingSupplierResponseError = (registerEInvoicingSupplierResponse400 | registerEInvoicingSupplierResponse401 | registerEInvoicingSupplierResponse403 | registerEInvoicingSupplierResponse404 | registerEInvoicingSupplierResponse422 | registerEInvoicingSupplierResponse500) & {
  headers: Headers;
};

export type registerEInvoicingSupplierResponse = (registerEInvoicingSupplierResponseSuccess | registerEInvoicingSupplierResponseError)

export const getRegisterEInvoicingSupplierUrl = () => {


  

  return `/e-invoicing/supplier`
}

export const registerEInvoicingSupplier = async (registerEInvoicingSupplierRequest: RegisterEInvoicingSupplierRequest, options?: RequestInit): Promise<registerEInvoicingSupplierResponse> => {
  
  return customFetch<registerEInvoicingSupplierResponse>(getRegisterEInvoicingSupplierUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      registerEInvoicingSupplierRequest,)
  }
);}
  

/**
 * Get the current e-invoicing supplier onboarding status for this entity.
 * @summary Get supplier status
 */
export type getEInvoicingSupplierResponse200 = {
  data: EInvoicingSupplier
  status: 200
}

export type getEInvoicingSupplierResponse401 = {
  data: Error
  status: 401
}

export type getEInvoicingSupplierResponse403 = {
  data: Error
  status: 403
}

export type getEInvoicingSupplierResponse404 = {
  data: Error
  status: 404
}

export type getEInvoicingSupplierResponse500 = {
  data: Error
  status: 500
}

export type getEInvoicingSupplierResponseSuccess = (getEInvoicingSupplierResponse200) & {
  headers: Headers;
};
export type getEInvoicingSupplierResponseError = (getEInvoicingSupplierResponse401 | getEInvoicingSupplierResponse403 | getEInvoicingSupplierResponse404 | getEInvoicingSupplierResponse500) & {
  headers: Headers;
};

export type getEInvoicingSupplierResponse = (getEInvoicingSupplierResponseSuccess | getEInvoicingSupplierResponseError)

export const getGetEInvoicingSupplierUrl = () => {


  

  return `/e-invoicing/supplier`
}

export const getEInvoicingSupplier = async ( options?: RequestInit): Promise<getEInvoicingSupplierResponse> => {
  
  return customFetch<getEInvoicingSupplierResponse>(getGetEInvoicingSupplierUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update supplier onboarding data (company details). Only allowed before onboarding is complete.
 * @summary Update supplier data
 */
export type updateEInvoicingSupplierResponse200 = {
  data: EInvoicingSupplier
  status: 200
}

export type updateEInvoicingSupplierResponse400 = {
  data: Error
  status: 400
}

export type updateEInvoicingSupplierResponse401 = {
  data: Error
  status: 401
}

export type updateEInvoicingSupplierResponse403 = {
  data: Error
  status: 403
}

export type updateEInvoicingSupplierResponse404 = {
  data: Error
  status: 404
}

export type updateEInvoicingSupplierResponse422 = {
  data: ValidationError
  status: 422
}

export type updateEInvoicingSupplierResponse500 = {
  data: Error
  status: 500
}

export type updateEInvoicingSupplierResponseSuccess = (updateEInvoicingSupplierResponse200) & {
  headers: Headers;
};
export type updateEInvoicingSupplierResponseError = (updateEInvoicingSupplierResponse400 | updateEInvoicingSupplierResponse401 | updateEInvoicingSupplierResponse403 | updateEInvoicingSupplierResponse404 | updateEInvoicingSupplierResponse422 | updateEInvoicingSupplierResponse500) & {
  headers: Headers;
};

export type updateEInvoicingSupplierResponse = (updateEInvoicingSupplierResponseSuccess | updateEInvoicingSupplierResponseError)

export const getUpdateEInvoicingSupplierUrl = () => {


  

  return `/e-invoicing/supplier`
}

export const updateEInvoicingSupplier = async (updateEInvoicingSupplierRequest: UpdateEInvoicingSupplierRequest, options?: RequestInit): Promise<updateEInvoicingSupplierResponse> => {
  
  return customFetch<updateEInvoicingSupplierResponse>(getUpdateEInvoicingSupplierUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateEInvoicingSupplierRequest,)
  }
);}
  

/**
 * Check if a recipient is registered on the Peppol network and can receive e-invoices.
 * @summary Search Peppol customer
 */
export type searchEInvoicingCustomerResponse200 = {
  data: SearchEInvoicingCustomer200
  status: 200
}

export type searchEInvoicingCustomerResponse400 = {
  data: Error
  status: 400
}

export type searchEInvoicingCustomerResponse401 = {
  data: Error
  status: 401
}

export type searchEInvoicingCustomerResponse403 = {
  data: Error
  status: 403
}

export type searchEInvoicingCustomerResponse404 = {
  data: Error
  status: 404
}

export type searchEInvoicingCustomerResponse422 = {
  data: ValidationError
  status: 422
}

export type searchEInvoicingCustomerResponse500 = {
  data: Error
  status: 500
}

export type searchEInvoicingCustomerResponseSuccess = (searchEInvoicingCustomerResponse200) & {
  headers: Headers;
};
export type searchEInvoicingCustomerResponseError = (searchEInvoicingCustomerResponse400 | searchEInvoicingCustomerResponse401 | searchEInvoicingCustomerResponse403 | searchEInvoicingCustomerResponse404 | searchEInvoicingCustomerResponse422 | searchEInvoicingCustomerResponse500) & {
  headers: Headers;
};

export type searchEInvoicingCustomerResponse = (searchEInvoicingCustomerResponseSuccess | searchEInvoicingCustomerResponseError)

export const getSearchEInvoicingCustomerUrl = () => {


  

  return `/e-invoicing/customer-search`
}

export const searchEInvoicingCustomer = async (eInvoicingCustomerSearchRequest: EInvoicingCustomerSearchRequest, options?: RequestInit): Promise<searchEInvoicingCustomerResponse> => {
  
  return customFetch<searchEInvoicingCustomerResponse>(getSearchEInvoicingCustomerUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      eInvoicingCustomerSearchRequest,)
  }
);}
  

/**
 * Send a document as an e-invoice via the Peppol network. Generates UBL XML and submits to Flowin.
 * @summary Send e-invoice
 */
export type sendEInvoiceResponse201 = {
  data: EInvoicingSubmission
  status: 201
}

export type sendEInvoiceResponse400 = {
  data: Error
  status: 400
}

export type sendEInvoiceResponse401 = {
  data: Error
  status: 401
}

export type sendEInvoiceResponse403 = {
  data: Error
  status: 403
}

export type sendEInvoiceResponse404 = {
  data: Error
  status: 404
}

export type sendEInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type sendEInvoiceResponse500 = {
  data: Error
  status: 500
}

export type sendEInvoiceResponseSuccess = (sendEInvoiceResponse201) & {
  headers: Headers;
};
export type sendEInvoiceResponseError = (sendEInvoiceResponse400 | sendEInvoiceResponse401 | sendEInvoiceResponse403 | sendEInvoiceResponse404 | sendEInvoiceResponse422 | sendEInvoiceResponse500) & {
  headers: Headers;
};

export type sendEInvoiceResponse = (sendEInvoiceResponseSuccess | sendEInvoiceResponseError)

export const getSendEInvoiceUrl = () => {


  

  return `/e-invoicing/send/:documentType/:documentId`
}

export const sendEInvoice = async (sendEInvoiceRequest: SendEInvoiceRequest, options?: RequestInit): Promise<sendEInvoiceResponse> => {
  
  return customFetch<sendEInvoiceResponse>(getSendEInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      sendEInvoiceRequest,)
  }
);}
  

/**
 * List e-invoice submissions with pagination.
 * @summary List submissions
 */
export type listEInvoicingSubmissionsResponse200 = {
  data: ListEInvoicingSubmissions200
  status: 200
}

export type listEInvoicingSubmissionsResponse400 = {
  data: Error
  status: 400
}

export type listEInvoicingSubmissionsResponse401 = {
  data: Error
  status: 401
}

export type listEInvoicingSubmissionsResponse403 = {
  data: Error
  status: 403
}

export type listEInvoicingSubmissionsResponse404 = {
  data: Error
  status: 404
}

export type listEInvoicingSubmissionsResponse500 = {
  data: Error
  status: 500
}

export type listEInvoicingSubmissionsResponseSuccess = (listEInvoicingSubmissionsResponse200) & {
  headers: Headers;
};
export type listEInvoicingSubmissionsResponseError = (listEInvoicingSubmissionsResponse400 | listEInvoicingSubmissionsResponse401 | listEInvoicingSubmissionsResponse403 | listEInvoicingSubmissionsResponse404 | listEInvoicingSubmissionsResponse500) & {
  headers: Headers;
};

export type listEInvoicingSubmissionsResponse = (listEInvoicingSubmissionsResponseSuccess | listEInvoicingSubmissionsResponseError)

export const getListEInvoicingSubmissionsUrl = (params?: ListEInvoicingSubmissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/e-invoicing/submissions?${stringifiedParams}` : `/e-invoicing/submissions`
}

export const listEInvoicingSubmissions = async (params?: ListEInvoicingSubmissionsParams, options?: RequestInit): Promise<listEInvoicingSubmissionsResponse> => {
  
  return customFetch<listEInvoicingSubmissionsResponse>(getListEInvoicingSubmissionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get detailed submission status including UBL XML.
 * @summary Get submission detail
 */
export type getEInvoicingSubmissionResponse200 = {
  data: EInvoicingSubmissionDetail
  status: 200
}

export type getEInvoicingSubmissionResponse401 = {
  data: Error
  status: 401
}

export type getEInvoicingSubmissionResponse403 = {
  data: Error
  status: 403
}

export type getEInvoicingSubmissionResponse404 = {
  data: Error
  status: 404
}

export type getEInvoicingSubmissionResponse500 = {
  data: Error
  status: 500
}

export type getEInvoicingSubmissionResponseSuccess = (getEInvoicingSubmissionResponse200) & {
  headers: Headers;
};
export type getEInvoicingSubmissionResponseError = (getEInvoicingSubmissionResponse401 | getEInvoicingSubmissionResponse403 | getEInvoicingSubmissionResponse404 | getEInvoicingSubmissionResponse500) & {
  headers: Headers;
};

export type getEInvoicingSubmissionResponse = (getEInvoicingSubmissionResponseSuccess | getEInvoicingSubmissionResponseError)

export const getGetEInvoicingSubmissionUrl = () => {


  

  return `/e-invoicing/submissions/:id`
}

export const getEInvoicingSubmission = async ( options?: RequestInit): Promise<getEInvoicingSubmissionResponse> => {
  
  return customFetch<getEInvoicingSubmissionResponse>(getGetEInvoicingSubmissionUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retry a failed or rejected e-invoice submission.
 * @summary Retry failed submission
 */
export type retryEInvoicingSubmissionResponse200 = {
  data: EInvoicingSubmission
  status: 200
}

export type retryEInvoicingSubmissionResponse400 = {
  data: Error
  status: 400
}

export type retryEInvoicingSubmissionResponse401 = {
  data: Error
  status: 401
}

export type retryEInvoicingSubmissionResponse403 = {
  data: Error
  status: 403
}

export type retryEInvoicingSubmissionResponse404 = {
  data: Error
  status: 404
}

export type retryEInvoicingSubmissionResponse422 = {
  data: ValidationError
  status: 422
}

export type retryEInvoicingSubmissionResponse500 = {
  data: Error
  status: 500
}

export type retryEInvoicingSubmissionResponseSuccess = (retryEInvoicingSubmissionResponse200) & {
  headers: Headers;
};
export type retryEInvoicingSubmissionResponseError = (retryEInvoicingSubmissionResponse400 | retryEInvoicingSubmissionResponse401 | retryEInvoicingSubmissionResponse403 | retryEInvoicingSubmissionResponse404 | retryEInvoicingSubmissionResponse422 | retryEInvoicingSubmissionResponse500) & {
  headers: Headers;
};

export type retryEInvoicingSubmissionResponse = (retryEInvoicingSubmissionResponseSuccess | retryEInvoicingSubmissionResponseError)

export const getRetryEInvoicingSubmissionUrl = () => {


  

  return `/e-invoicing/submissions/:id/retry`
}

export const retryEInvoicingSubmission = async ( options?: RequestInit): Promise<retryEInvoicingSubmissionResponse> => {
  
  return customFetch<retryEInvoicingSubmissionResponse>(getRetryEInvoicingSubmissionUrl(),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}
  

/**
 * Internal endpoint for receiving status updates from Flowin. Not intended for direct API use.
 * @summary Flowin webhook receiver
 */
export type handleFlowinWebhookResponse200 = {
  data: void
  status: 200
}

export type handleFlowinWebhookResponse401 = {
  data: void
  status: 401
}

export type handleFlowinWebhookResponseSuccess = (handleFlowinWebhookResponse200) & {
  headers: Headers;
};
export type handleFlowinWebhookResponseError = (handleFlowinWebhookResponse401) & {
  headers: Headers;
};

export type handleFlowinWebhookResponse = (handleFlowinWebhookResponseSuccess | handleFlowinWebhookResponseError)

export const getHandleFlowinWebhookUrl = () => {


  

  return `/e-invoicing/webhooks/flowin`
}

export const handleFlowinWebhook = async (handleFlowinWebhookBody: HandleFlowinWebhookBody, options?: RequestInit): Promise<handleFlowinWebhookResponse> => {
  
  return customFetch<handleFlowinWebhookResponse>(getHandleFlowinWebhookUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      handleFlowinWebhookBody,)
  }
);}
  

